/**
 * Shared types for the Contractor Analysis report. The page fetches data
 * from three BFF endpoints and projects it into these shapes before
 * threading them into the sub-components — see `ContractorAnalysisReportPage`.
 */

/** Personnel-section range tab — translates to a dateFrom/dateTo window. */
export type ContractorRange = '7d' | '14d' | '30d';

/** Ordered list of valid preset ranges. */
export const CONTRACTOR_RANGES: readonly ContractorRange[] = ['7d', '14d', '30d'] as const;

/** Map a `Nd` preset key onto the number of days it represents. */
export function presetDays(preset: ContractorRange): number {
  return Number.parseInt(preset, 10);
}

/** One bar in the Workers-vs-Hours combo chart. */
export interface IDailyWorkersHours {
  /** ISO yyyy-MM-dd date in the project tz. */
  date: string;
  workers: number;
  hours: number;
}

/** One row in the Location Distribution list. */
export interface ILocationShare {
  id: string;
  /** Display label — e.g. "floor 19", "lobby", "B1 East". */
  label: string;
  /** Coarser grouping — used to swap the axis in `LocationDistribution`. */
  floor: string;
  /** % of working time at this location. Sums to ~100 across all items. */
  percent: number;
}
